<template>
    <div :class="['lc-toast', `lc-toast--${type}`]">
        <svg
            class="lc-toast__icon"
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        >
            <g v-html="iconPath" />
        </svg>
        <span class="lc-toast__msg">{{ message }}</span>
        <button
            class="lc-toast__close"
            @click.stop="$emit('close')"
        >
            &times;
        </button>
    </div>
</template>

<script>
    const ICONS = {
        success: '<path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><path d="m9 11 3 3L22 4"/>',
        error: '<circle cx="12" cy="12" r="10"/><path d="m15 9-6 6m0-6 6 6"/>',
        warning: '<circle cx="12" cy="12" r="10"/><path d="M12 16v-4m0-4h.01"/>',
        info: '<circle cx="12" cy="12" r="10"/><path d="M12 16v-4m0-4h.01"/>',
        delete: '<path d="m3 6 2 0m16 0-2 0m-10 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2m3 0v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6h16z"/><path d="M10 11v6m4-6v6"/>',
    }

    export default {
        name: 'LcToast',
        props: {
            type: {
                type: String,
                default: 'info',
                validator: (v) => ['success', 'error', 'info', 'warning', 'delete'].includes(v),
            },
            message: { type: String, required: true },
        },
        emits: ['close'],
        computed: {
            iconPath() {
                return ICONS[this.type] || ICONS.info
            },
        },
    }
</script>

<style lang="scss" scoped>
.lc-toast {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.12);
    padding: 12px 14px;
    margin-bottom: 8px;
    border-left: 3px solid;
    animation: lc-toast-in 0.25s ease;

    &--success { border-left-color: #10b981; .lc-toast__icon { color: #10b981; } }
    &--error   { border-left-color: #ef4444; .lc-toast__icon { color: #ef4444; } }
    &--warning { border-left-color: #f59e0b; .lc-toast__icon { color: #f59e0b; } }
    &--info    { border-left-color: #3b82f6; .lc-toast__icon { color: #3b82f6; } }
    &--delete  { border-left-color: #ef4444; .lc-toast__icon { color: #ef4444; } }
}

.lc-toast__icon {
    flex-shrink: 0;
    margin-top: 1px;
}

.lc-toast__msg {
    flex: 1;
    font-size: 13px;
    line-height: 1.4;
    color: #334155;
    white-space: pre-line;
}

.lc-toast__close {
    flex-shrink: 0;
    padding: 0;
    width: 18px;
    height: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    line-height: 1;
    color: #999;
    background: none;
    border: none;
    cursor: pointer;
    opacity: 0.5;
    transition: opacity 0.15s;

    &:hover { opacity: 1; }
}

@keyframes lc-toast-in {
    from { transform: translateX(calc(100% + 1rem)); opacity: 0; }
    to   { transform: translateX(0); opacity: 1; }
}
</style>
